import React from 'react';
import './style.less';


interface MainContainerProps {
  children: React.ReactNode,
  scrollable?: boolean
}

const clsPrefix = 'ly-main-container';
const MainContainer: React.FC<MainContainerProps> = (props) => {
  return (
    <div className={clsPrefix}>
        <div className={`${clsPrefix}__card`}>
            {props.children}
        </div>
    </div>
  )
}

MainContainer.propTypes = {
  children: undefined,
}

export default MainContainer;